export const clinicalHomeUtilsCard_style = {};
